export var addElement = function (id) {
    var element = document.createElement('div');
    element.setAttribute('id', id);
    return element;
};
export var removeElement = function (id) {
    var element = document.getElementById(id);
    if (element)
        element.remove();
};
export var addElementClass = function (id, className) {
    var element = document.getElementById(id);
    if (element)
        element.classList.add(className);
};
export var removeElementClass = function (id, className) {
    var element = document.getElementById(id);
    if (element)
        element.classList.remove(className);
};
export var appendToBody = function (rootElem) {
    document.body.appendChild(rootElem);
};
export var addContainer = function (id) {
    var toastContainer = document.getElementById(id);
    if (!toastContainer)
        appendToBody(addElement(id));
};
